/* eslint-disable import/namespace */
import * as serverEndPoints from "@/server/endpoints"
import { requestErrorMessage } from "@/utils/requestError"

export const useHttpRequest = async (endpoint, options) => {
  const app = useNuxtApp()
  const { globalLoading = true, suppressErrorToast = false, ...requestOptions } = options || {}
  const { startRequest, finishRequest } = useApiLoading()
  const notify = message => {
    if (!suppressErrorToast && message) app.$toast(message, {
      position: "bottom-center", rtl: true, theme: "colored", type: "error", hideProgressBar: true,
    })
  }
  if (globalLoading) startRequest()
  try {
    const [category, categoryName] = endpoint.split(".")
    const { path, method } = serverEndPoints[category][categoryName]
    const { error, data } = await useApi(path, { method, ...requestOptions })
    const errorMessage = requestErrorMessage(error?.value)
    notify(errorMessage)
    return { data, error, isSuccess: !error?.value, errorMessage }
  } catch (error) {
    const errorMessage = requestErrorMessage(error)
    notify(errorMessage)
    return { data: ref(null), error: ref(error), isSuccess: false, errorMessage }
  } finally {
    if (globalLoading) finishRequest()
  }
}
